<template lang="pug">
   v-card
      v-toolbar(dark dense color="red" class="navFixed")
        v-toolbar-title IM Preview
        v-spacer
        v-toolbar-items
          v-btn(v-if="imItems.imFileLampiran" flat @click="download(imItems.imFileLampiran)" title="Download Lampiran")
            v-icon cloud_download
            | &nbsp; Lampiran
          v-btn(flat @click='printIM(imItems._id)')
            v-icon print
            | &nbsp; Print
          v-btn(dark flat onclick="javascript:window.close();") 
            v-icon(title="Close") cancel
            | &nbsp;Close
      v-list(three-line subheader class="print-bg padTop60")
        div(:id="imItems._id")
          .page(size="Auto")
            table(id="header-view" class="view-width print-header")
              tbody
                tr
                  td(class="logo-cell" v-if="imItems.imType != 10") 
                    img(v-if="imItems.imGroup === 'gems'" src="../assets/smm-logo.png" class="width-300px")
                    img(v-else src="../assets/bc-logo-188.png" class="width-300px")
            div(class="view-width" style="font-size:14px;")
              h2(style="text-align:center;padding:5px;") INTERNAL MEMO
              hr(v-if="imItems.imType < 5" style="border-style: inset;border-width: 2px;")
              table(v-if="imItems.imType == 5" class="view-width" style="margin-top:10px;")
                tbody
                  tr
                    td(width="100") No.
                    td(width="10") :
                    td {{ imItems.imNo }}
                  tr
                    td Kepada
                    td :
                    td {{ imItems.imKepada }}
                  tr
                    td Dari
                    td :
                    td {{ imItems.imDari }}
                  tr
                    td Tanggal
                    td :
                    td {{ getTanggal(imItems.imDate) }}
                  tr
                    td Perihal
                    td :
                    td 
                      strong {{ imItems.imPerihal }}
              table(v-else class="view-width" style="margin-top:10px;")
                tbody
                  tr
                    td(style="font-size:15px;") 
                      strong KEPADA / TO : BAPAK/IBU
                    td(style="font-size:15px;")
                      strong DARI / FROM :
                  tr
                    td(valign="top")
                      ul
                        li(v-for="item in imItems.imApprover.slice().reverse()" style="font-size:15px;") {{ item.fullname }} 
                    td(valign="top") 
                      ul(style="list-style-type: none; padding:0;")
                        li(style="font-size:15px;border-bottom:1px solid grey;") {{ imItems.imUser.fullname }}
                        li(style="font-size:15px;border-bottom:1px solid grey;")  
                          strong NOMOR / NUMBER
                          br
                          | {{ imItems.imNo }}
                        li(style="font-size:15px;border-bottom:1px solid grey;")  
                          strong TANGGAL / DATE
                          br
                          | {{ imItems.imDate ? getTanggal(imItems.imDate) : '-' }}
                        li(style="font-size:15px;border-bottom:1px solid grey;")  
                          strong PERIHAL / ISSUE
                          br
                          | {{ imItems.imPerihal }}
              table(v-if="imItems.imType < 5" class="view-width" style="margin-top:5px;")
                tbody
                  tr
                    td(style="font-size:15px;") 
                      strong TIPE IM :
                      | &nbsp;{{ i18n.imType[imItems.imType] }}{{ imItems.imType == 3 ? ` (${imItems.imVendor.name}${imItems.imVendor.appointed > 0 ? ' : sudah pernah ditunjuk '+imItems.imVendor.appointed+' kali' : '' })` : '' }}
                  tr(v-if="imItems.imType == 3")
                    td(style="font-size:15px;") 
                      strong ALASAN :
                      | &nbsp;{{ imItems.imAlasan }}
                  tr
                    td(style="font-size:15px;") 
                      //- span(v-for="item in imItems.imCC" class="pr-2") {{item.name}}, 
                      span(v-for="(item, index) in imItems.imCC" class="pr-2" v-if="index !== imItems.imCC.length-1") {{item.name}},
                      span(v-else) {{item.name}} 
              hr(v-if="imItems.imType < 5" style="border-style: inset;border-width: 2px;margin-top:10px;")
              div(v-if="imItems.imType < 5" style="margin-bottom:1px;")
                label(class="containerLbl") URGENT
                  input(v-if="imItems.imPrioritas == 1" type="checkbox" checked="checked" disabled)
                  input(v-else type="checkbox" disabled)
                  span(class="checkmark")
                label(class="containerLbl") FOR REVIEW
                  input(v-if="imItems.imPrioritas == 2" type="checkbox" checked="checked" disabled)
                  input(v-else type="checkbox" disabled)
                  span(class="checkmark")
                label(class="containerLbl") FOR COMMENT
                  input(v-if="imItems.imPrioritas == 3" type="checkbox" checked="checked" disabled)
                  input(v-else type="checkbox" disabled)
                  span(class="checkmark")
                label(class="containerLbl") PLEASE REPLY
                  input(v-if="imItems.imPrioritas == 4" type="checkbox" checked="checked" disabled)
                  input(v-else type="checkbox" disabled)
                  span(class="checkmark")
                label(class="containerLbl") PLEASE RECYCLE
                  input(v-if="imItems.imPrioritas == 5" type="checkbox" checked="checked" disabled)
                  input(v-else type="checkbox" disabled)
                  span(class="checkmark")
              hr(style="border-style: inset;border-width: 2px;")
              div(v-if="imItems.imType < 5" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") TUJUAN
                div(v-html="imItems.imTujuan")
              div(v-if="imItems.imType < 5" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") LATAR BELAKANG
                div(v-html="imItems.imLatarBelakang")
              div(v-if="imItems.imType < 5" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") MENGUSULKAN
                div(v-html="imItems.imUsulan")
              div(v-if="imItems.imType < 5" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") NILAI PENGAJUAN PROJECT BUDGET
                div(v-html="getFormatCurrency(imItems.imValue)")
              div(v-if="imItems.imType < 5" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") TARGET DELIVERY DATE
                div(v-html="getTanggal(imItems.imTargetDate)")
              div(v-if="imItems.imType == 1 || imItems.imType == 2" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") Nomor Dokumen SAP
                div(v-html="imItems.imNoDocument")
              div(v-if="imItems.imType < 5" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;")
                p Demikian permohonan ini kami buat, atas persetujuan Bapak/Ibu, kami ucapkan terima kasih.
              div(v-if="imItems.imType == 5" style="text-align:justify;margin-top:15px;")
                div(v-html="imItems.imUsulan")
            //div(style="position:absolute;bottom:20px;right:35px;font-size:12px") {{ imItems.imNo }}
          .page(size="A4")
            table(id="header-view" class="view-width print-header")
              tbody
                tr
                  td(class="logo-cell" v-if="imItems.imType != 10") 
                    img(v-if="imItems.imGroup === 'gems'" src="../assets/smm-logo.png" class="width-300px")
                    img(v-else src="../assets/bc-logo-188.png" class="width-300px")
            p(style="font-size:14px;font-weight:bold;margin-bottom:-10px;") Approval list for IM No : {{imItems.imNo}}
            div(class="view-width detail-wrap" style="font-size:14px;")
              table(class="view-width" border="1" style="margin:10px 0;border:1px solid black;border-collapse: collapse;text-align:center")
                tbody
                  tr(v-if="imItems.imType != 5")
                    td(colspan="3" style="") 
                      b Diajukan oleh,
                  tr(v-if="imItems.imType != 5")
                    td(width="36%") 
                      b Nama/Jabatan
                    td(width="32%") 
                      b Komentar
                    td(width="32%")
                      b Tanda Tangan Digital
                  tr(v-if="imItems.imType != 5")
                    td(height="100px")
                      b {{ imItems.imUser.fullname }} / {{ imItems.imUser.title }}
                    td 
                    td 
                      div(v-if="imItems.imStatus == 5" class="approved")
                        img(src="../assets/close-64.png" style="width:25px;")
                        br
                        | {{ 'User Withdraw'+ (imItems.withdrawDate ? ' at '+getTanggal(imItems.withdrawDate) : '') }}<br />
                      div(v-else class="approved")
                        img(src="../assets/check-64.png" style="width:25px;")
                        br
                        | {{ imItems.imDate ? getTanggal(imItems.imDate) : '-' }}
                  tr(v-if="imItems.imType != 5" v-for="(item,index) in imItems.imWorkflow")
                    td(v-if="item.userType == 2 && item.postAs == 'requestor'" height="100px")
                      b {{ item.fullname }} / {{ item.title }}
                    td(v-if="item.userType == 2 && item.postAs == 'requestor'") {{ item.comment ? item.comment : '' }}
                    td(v-if="item.userType == 2 && item.postAs == 'requestor'") 
                      div(v-if="(imItems.imStatus == 2 || imItems.imStatus == 3 || imItems.imStatus == 4 || imItems.imStatus == 8 || imItems.imStatus == 5) && (item.status == 7 || item.status == 4)" class="approved") 
                        img(src="../assets/check-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                        //- | Leadtime : {{ countLeadtime(item.date, imItems.imDate) }} hari
                      div(v-else-if="(imItems.imStatus == 2 || imItems.imStatus == 3 || imItems.imStatus == 4 || imItems.imStatus == 8 || imItems.imStatus == 5) && item.status == 8" class="approved") 
                        img(src="../assets/close-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                        //- | Leadtime : {{ countLeadtime(item.date, imItems.imDate) }} hari
                      div(v-else class="approved ff0000") &nbsp; <br />&nbsp; <br />&nbsp; <br />
                  tr
                    td(colspan="3" align="center" style="") 
                      b Disetujui oleh,
                  tr(v-for="(item,index) in imItems.imWorkflow")
                    td(v-if="item.userType == 2 && item.postAs != 'requestor'" height="100px" width="36%")
                      b {{ item.fullname }} / {{ item.title }}
                    td(v-if="item.userType == 2 && item.postAs != 'requestor'" width="32%") {{ item.comment ? item.comment : '' }}
                    td(v-if="item.userType == 2 && item.postAs != 'requestor'" width="32%") 
                      div(v-if="(imItems.imStatus == 2 || imItems.imStatus == 3 || imItems.imStatus == 4 || imItems.imStatus == 8 || imItems.imStatus == 5) && (item.status == 7 || item.status == 4)" class="approved") 
                        img(src="../assets/check-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                        //- | Leadtime : {{ countLeadtime(item.date, imItems.imDate) }} hari
                      div(v-else-if="(imItems.imStatus == 2 || imItems.imStatus == 3 || imItems.imStatus == 4 || imItems.imStatus == 8 || imItems.imStatus == 5) && item.status == 8" class="approved") 
                        img(src="../assets/close-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                        //- | Leadtime : {{ countLeadtime(item.date, imItems.imDate) }} hari
                      div(v-else class="approved ff0000") &nbsp; <br />&nbsp; <br />&nbsp; <br />
                    td(v-if="item.userType == 4 && item.status != 5" height="100px" width="36%")
                      b {{ item.fullname }} / {{ item.title }}
                    td(v-if="item.userType == 4 && item.status != 5" width="32%") {{ item.comment ? item.comment : '' }}
                    td(v-if="item.userType == 4 && item.status != 5" width="32%")
                      div(v-if="(imItems.imStatus == 2 || imItems.imStatus == 3 || imItems.imStatus == 4 || imItems.imStatus == 8) && (item.status == 7 || item.status == 4)" class="approved") 
                        img(src="../assets/check-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                        //- | Leadtime : {{ countLeadtime(item.date, (index == 0 ?  imItems.imDate: imItems.imWorkflow[index-1].date) ) }} hari
                      div(v-else-if="(imItems.imStatus == 2 || imItems.imStatus == 3 || imItems.imStatus == 4 || imItems.imStatus == 8) && item.status == 8" class="approved") 
                        img(src="../assets/close-64.png" style="width:25px;")
                        br
                        | {{ item.date ? getTanggal(item.date) : '-' }}<br />
                        //- | Leadtime : {{ countLeadtime(item.date, (index == 0 ?  imItems.imDate: imItems.imWorkflow[index-1].date) ) }} hari
                      div(v-else class="approved ff0000") &nbsp; <br />&nbsp; <br />&nbsp; <br />
                      //span {{ value.fullname }}
              span(style="font-size:10px;color:red;") Silakan login pada aplikasi iMemo untuk memvalidasi kebenaran informasi atas tanda tangan digital di dokumen ini.
              //v-btn(v-if="imItems.imFileLampiran" small flat color="green" class="ma-0 pa-0" @click="download(imItems.imFileLampiran)")
                v-icon(color="green") cloud_download
                span &nbsp; Download Lampiran
            //div(style="position:absolute;bottom:20px;right:35px;font-size:12px") {{ imItems.imNo }}
</template>

<script>
// import axios from 'axios';
import { mapState } from "vuex";
import * as i18n from "../data/i18n.json";
export default {
  name: "IMViewSearch",
  props: {
    imItems: Object
  },
  data: () => ({
    i18n: i18n.default
  }),
  computed: {
    ...mapState(["API_URL"]),
    /*userApproval:function() {
      let workflow = [];
      let imWF = this.imItems.imWorkflow;
      let spvFlag = 1;
      var itSiteReject = false;
      var itSiteRejectDate = '';
      for (let l = 0; l < imWF.length; l++) {
        if (imWF[l].status != 5 && imWF[l].status != 10) {
          if (imWF[l].userType == 4) {
            if (!imWF[l+1]) {
              if (itSiteReject) {
                imWF[l].status = 8;
                imWF[l].itSiteReject = true;
                imWF[l].itSiteRejectDate = itSiteRejectDate;
              }
              workflow.push(imWF[l]);
            }
          } else {
            if (imWF[l].userType == 2 && spvFlag < 2) {
              workflow.push(imWF[l]);
              spvFlag++;
            }
            if (imWF[l].userType == 3 && imWF[l].status == 8) {
              itSiteReject = true;
              itSiteRejectDate = imWF[l].date;
            }
          }
        }
        if (imWF[l].status == 5) this.imItems.withdrawDate = imWF[l].date;
      }
      //if (this.userDetail.group === 'gems') {
        workflow.push(
          {
            status: 11,
            fullname: "..........................", 
            title: "In Charge", 
            userType: 5
          }
        );
      //}
      return workflow;
    }*/
  },
  methods: {
    printIM: function(id) {
      printJS({
        printable: id, 
        type: 'html',
        targetStyles: ['*']
      });
    },
    getTanggal: function(tgl) {
      let monthNames = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
      let tanggal = new Date(tgl);
      let month = tanggal.getMonth();
      let date = tanggal.getDate() < 10 ? '0'+tanggal.getDate() : tanggal.getDate();
      return date+' '+monthNames[month]+' '+tanggal.getFullYear();
    },
    countLeadtime: function(d1, d2) {
      const tgl1 = new Date(d1);
      const tgl2 = new Date(d2);
      const date1 = new Date(tgl1.getFullYear()+'-'+(tgl1.getMonth()+1)+'-'+tgl1.getDate());
      const date2 = new Date(tgl2.getFullYear()+'-'+(tgl2.getMonth()+1)+'-'+tgl2.getDate());
      const timeDiff = Math.abs(date2.getTime() - date1.getTime());
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return diffDays;
    },
    getFormatCurrency: function(imValue){
        const localization = imValue.currency == 'IDR' ? 'id-ID': 'en-US';
        const formatter = new Intl.NumberFormat(localization, {
          style: 'currency',
          currency: imValue.currency,
          minimumFractionDigits: 0
        })
        return formatter.format(imValue.value);
    },
    download(files) {
      if (Array.isArray(files)) {
        for (const key in files) {
          window.open(`${this.API_URL}/fileupload/${files[key]}`, '_blank');
        }
      } else {
        window.open(`${this.API_URL}/fileupload/${files}`, '_blank');
      }
    }
  } 
};
</script>

<style scoped>
.print-bg {
  background: rgb(204,204,204);
  padding-top: 10px;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
  page-break-before: always;
}
.page[size="Auto"] {
  width: 21cm;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:3px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  font-size: 11px;
  padding: 15px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align:top;
}

/* The containerLbl */
.containerLbl {
  position: relative;
  padding-left: 20px;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.containerLbl input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.containerLbl:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.containerLbl input:checked ~ .checkmark {
  background-color: #000000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.containerLbl input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.containerLbl .checkmark:after {
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
</style>